export default [
    {
      path: "/tags/list",
      name: "tags-list",
      component: () => import("@/views/pages/tags/tags-list/TagsList.vue"),
      meta: {},
      breadcrumb: [
        {
          text: 'Tags'
        },
        {
          text: 'Tags List',
          active: true,
        },
      ],
    },
    {
      path: "/tags/create",
      name: "tags-create",
      component: () => import("@/views/pages/tags/tags-info/TagsInfo.vue"),
      meta: {},
      breadcrumb: [
        {
          text: 'Tags'
        },
        {
          text: 'Add Tag',
          active: true,
        },
      ],
    },
    {
        path: "/tags/info/:ref",
        name: "tags-info",
        component: () => import("@/views/pages/tags/tags-info/TagsInfo.vue"),
        meta: {},
        breadcrumb: [
          {
            text: 'Tags'
          },
          {
            text: 'Add Tag',
            active: true,
          },
        ],
      },
    {
      path: "/tags/report",
      name: "tags-report",
      component: () => import("@/views/pages/tags/tags-report/TagsReport.vue"),
      meta: {},
      breadcrumb: [
        {
          text: 'Tags'
        },
        {
          text: 'Report',
          active: true,
        },
      ],
    },
  ];
  